<template>
  <div class="page-add">
    <div class="add-title">办班计划审核详情</div>
    <div class="detail-item">
      <div class="item-label">关联申报：</div>
      <div class="item-content">{{ info.reportName }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">申报部门：</div>
      <div class="item-content">{{ info.reportDeptName }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">班级名称：</div>
      <div class="item-content">{{ info.className }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训时间：</div>
      <div class="item-content">{{ info.trainTime }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训天数：</div>
      <div class="item-content">{{ info.trainDays }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训地点：</div>
      <div class="item-content">{{ info.trainPlace }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">承办单位：</div>
      <div class="item-content">{{ info.undertakeUnit }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">参训人数：</div>
      <div class="item-content">{{ info.trainNum }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">人均经费：</div>
      <div class="item-content">{{ info.perFunds }}元</div>
    </div>
    <div class="detail-item">
      <div class="item-label">参训对象：</div>
      <div class="item-content">{{ info.trainPerson }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">培训内容：</div>
      <div class="item-content">{{ info.desc }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">是否外出考察(选填)：</div>
      <div class="item-content">{{ info.externalInvestigation }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">联系人(选填)：</div>
      <div class="item-content">{{ info.liaison }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">联系方式(选填)：</div>
      <div class="item-content">{{ info.liaisonPhone }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">分管领导(选填)：</div>
      <div class="item-content">{{ info.leader }}</div>
    </div>
    <div class="detail-item">
      <div class="item-label">分管领导联系方式(选填)：</div>
      <div class="item-content">{{ info.leaderPhone }}</div>
    </div>
    <div class="detail-item" v-if="attachment.length > 0">
      <div class="item-label">附件(需盖单位公章)：</div>
      <div class="item-content">
        <downItem :source="JSON.parse(info.attachment)[0]" />
      </div>
    </div>
    <div class="grey-head">审核详情</div>
    <div class="block">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in steps"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="
            activity.auditDate == null
              ? ''
              : activity.auditDate + '\u3000' + activity.auditContent
          "
        >
          {{ activity.auditUserName }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="text-center">
      <el-button size="small" @click="$router.go(-1)">返回</el-button>
      <el-button size="small" type="primary" @click="changeRes">{{
        $route.query.auditStatus == 0 ? "审核" : "修改审核结果"
      }}</el-button>
    </div>
    <audit-dialog :dialogInfo="dialogInfo" @close="close" />
  </div>
</template>

<script>
import downItem from "@/views/declareClassPlan/detail/downItem.vue";
import { classReportPlanInfo, auditInfo } from "@/api/studyService";
import AuditDialog from "@/views/classReport/manage/auditDialog.vue";

export default {
  name: "classReportManageDetail",
  components: {
    downItem,
    AuditDialog,
  },
  data() {
    return {
      info: {},
      attachment: [],
      steps: [],
      dialogInfo: {
        show: false,
        title: "办班审核",
        auditMens: [],
      },
    };
  },
  created() {
    const { uuid, auditApplyId, auditUserId, auditUserName, className } =
      this.$route.query;
    this.dialogInfo.auditMens = [
      { auditApplyId, auditUserId, auditUserName, className },
    ];
    classReportPlanInfo({ uuid }).then(({ code, data }) => {
      if (code !== 0) return;
      this.info = data;
      let attachment = JSON.parse(data.attachment) || "";
      if (attachment.length > 0) {
        this.attachment = attachment;
      }
    });
    this.getAuditInfo(auditApplyId);
  },
  methods: {
    getAuditInfo(auditApplyId) {
      auditInfo({ auditApplyId }).then(({ code, data }) => {
        if (code !== 0) return;
        this.steps = data.map((x) => {
          return {
            ...x,
            icon: "el-icon-success",
            color: "#3A85FF",
            size: "large",
          };
        });
      });
    },
    close(flag) {
      this.getAuditInfo(this.$route.query.auditApplyId);
      this.dialogInfo.show = false;
    },
    changeRes() {
      this.dialogInfo.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  font-size: 14px;
  line-height: 40px;
}
.item-label {
  width: 180px;
  text-align: right;
}
.grey-head {
  line-height: 40px;
  padding: 0 15px;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  background: #f2f3f4;
  margin-bottom: 15px;
}
</style>
